// extracted by mini-css-extract-plugin
module.exports = {"isCopiedContainer":"IsCopiedMessage_isCopiedContainer__2KWWn","active":"IsCopiedMessage_active__1guKI"};